import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
export function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://cloudibs.com/">
        CloudIBS
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}
